import { AddressState } from '@src/const/address'
import Vue from 'vue'
// initial state
const state = {
  isOnline: false,
  isEnabledLocationService: false,
  token: null,
  info: null,
  point: {},
  inviterId: 0,
  isTokenInvalid: false,
  storeJoinin1: {store_type:1},
  storeJoinin0: {store_type:0},
  storeJoininType: 1,
  orderNum: 0,
  favoritePage: 0,
  deviceId: undefined,
  friend_invitation_code: undefined,
}

// mutations
const mutations = {
  setIsEnabledLocationService (state, payload) {
    state.isEnabledLocationService = payload
  },
  setFriendInvitationCode (state, payload) {
    state.friend_invitation_code = payload
  },
  sellerJoininSave (state, payload) {
    if(payload.storeJoinin.store_type==1){
      state.storeJoinin1 = Object.assign(
          state.storeJoinin1,
          payload.storeJoinin)
    }else{
      state.storeJoinin0 = Object.assign(
          state.storeJoinin0,
          payload.storeJoinin)
    }
  },
  sellerJoininTypeSave (state, payload) {
    state.storeJoininType = payload.storeJoininType
  },
  memberInviterId (state, payload) {
    state.inviterId = payload.inviterId
  },
  memberPoint (state, payload) {
    state.point = payload.point
  },
  memberLogin (state, payload) {
    state.point = {}
    state.info = payload.info
    state.info.invalid_time = parseInt((new Date().getTime()) / 1000) + 3600// 一小时更新
    state.isOnline = true
    state.token = payload.token
    state.isTokenInvalid = false
    if (process.env.NODE_ENV === 'development') {
      window.localStorage.setItem('device_id', payload.token)
    }
    import('@/util/bugsnag').then(() => {
        console.log('bugsnag is loaded')
    }).catch((err) => {
        console.error(err)
    })
    state.deviceId = window.localStorage.getItem('device_id')
    this._vm.$socket.io.opts.extraHeaders.authorization = state.token
    this._vm.$socket.io.opts.extraHeaders.client_type = "member"
    this._vm.$socket.disconnect().connect()
  },
  memberLogout (state) {
    state.point = {}
    state.info = null
    state.isOnline = false
    state.token = null
    state.friend_invitation_code = undefined
    state.isEnabledLocationService = false
    state.orderNum = 0
    if (process.env.NODE_ENV === 'development') {
      state.deviceId = undefined
    }
	  this._vm.$socket.disconnect()
  },
  memberUpdate (state, payload) {
    if (state.info) {
      state.info = payload.info
      state.info.invalid_time = parseInt((new Date().getTime()) / 1000) + 3600// 一小时更新
    }
  },
  memberEdit (state, payload) {
    if (state.info) {
      let i
      for (i in payload) {
        state.info[i] = payload[i]
      }
    }
  },
  orderNumUpdate(state, payload) {
    state.orderNum = payload
  },
  setFavoritePage (state, payload) {
    state.favoritePage = payload
  }
}

const actions = {
}

const getters = {
  memberInfo(state, getters) {		
		return state.info;
	},
}

export default {
  state,
  mutations,
  actions,
  getters
}
